import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import * as types from "@/store/constants/types";
import { sendMapEvent } from "@/utils/analytics";
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import fateSpec from "./fateSpec.vue";
import yearSpec from "./yearSpec.vue";
var vm;

var ShortFateCraouser =
/*#__PURE__*/
function (_Vue) {
  _inherits(ShortFateCraouser, _Vue);

  function ShortFateCraouser() {
    var _this;

    _classCallCheck(this, ShortFateCraouser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShortFateCraouser).apply(this, arguments));
    _this.slideIndex = 0;
    _this.swiperOption = {
      // some swiper options/callbacks
      // 所有的参数同 swiper 官方 api 参数
      // ...
      centeredSlides: true,
      slidesPerView: 1.1,
      loop: true,
      observer: true,
      initialSlide: _this.slideIndex,
      observeParents: false,
      on: {
        tap: function tap(e) {
          var token = e.target.getAttribute('token');
          sendMapEvent("uia_card_click", {
            key: "horoscope"
          });
          vm.routerPush({
            name: "horoscopePage",
            query: {
              token: token
            },
            params: {
              routerTransition: "forward",
              changeSlide: true
            }
          });
        }
      }
    };
    return _this;
  }

  _createClass(ShortFateCraouser, [{
    key: "created",
    value: function created() {
      vm = this;
    }
  }, {
    key: "averageRate",
    get: function get() {
      var _this2 = this;

      var totalRate = 0;

      if (!this.todayHorosopeFate) {
        return 0;
      }

      _Object$keys(this.todayHorosopeFate.rating).forEach(function (item) {
        if (item !== "category") {
          totalRate += _this2.todayHorosopeFate.rating[item];
        }
      });

      return (totalRate / 6).toFixed(1);
    }
  }, {
    key: "specList",
    get: function get() {
      if (!this.todayHorosopeFate || !this.tomorrowHorosopeFate || !this.weekHorosopeFate || !this.monthHorosopeFate) {
        return null;
      }

      return [{
        title: this.$t("horoscope_page.craouser.today_rating"),
        score: this.averageRate,
        content: this.todayHorosopeFate && this.todayHorosopeFate.summary && this.todayHorosopeFate.summary.article[0].text,
        token: 'today'
      }, {
        title: this.$t("horoscope_page.craouser.tomorrow"),
        content: this.tomorrowHorosopeFate && this.tomorrowHorosopeFate.summary && this.tomorrowHorosopeFate.summary.article[0].text,
        token: 'tomorrow'
      }, {
        token: 'year'
      }, {
        title: this.$t("horoscope_page.craouser.this_week"),
        content: this.weekHorosopeFate && this.weekHorosopeFate.summary && this.weekHorosopeFate.summary.article[0].text,
        token: 'week'
      }, {
        title: this.$t("horoscope_page.craouser.this_month"),
        content: this.monthHorosopeFate && this.monthHorosopeFate.summary && this.monthHorosopeFate.summary.article[0].text,
        token: 'month'
      }];
    }
  }]);

  return ShortFateCraouser;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], ShortFateCraouser.prototype, "routerPush", void 0);

tslib_1.__decorate([Getter(types.GETTER_HOROSCOPE)], ShortFateCraouser.prototype, "horoScope", void 0);

tslib_1.__decorate([Getter(types.GETTER_TODAY_HOROSCOPE_FATE)], ShortFateCraouser.prototype, "todayHorosopeFate", void 0);

tslib_1.__decorate([Getter(types.GETTER_TOMORROW_HOROSCOPE_FATE)], ShortFateCraouser.prototype, "tomorrowHorosopeFate", void 0);

tslib_1.__decorate([Getter(types.GETTER_WEEK_HOROSCOPE_FATE)], ShortFateCraouser.prototype, "weekHorosopeFate", void 0);

tslib_1.__decorate([Getter(types.GETTER_MONTH_HOROSCOPE_FATE)], ShortFateCraouser.prototype, "monthHorosopeFate", void 0);

ShortFateCraouser = tslib_1.__decorate([Component({
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    fateSpec: fateSpec,
    yearSpec: yearSpec
  }
})], ShortFateCraouser);
export default ShortFateCraouser;